import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/invoices.literals.selectors';

@Injectable({
  providedIn: 'root',
})
export class InvoiceLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  invoiceNumber$ = this.storeSelect(selectors.getInvoiceNumber);
  loyaltyCard$ = this.storeSelect(selectors.getLoyaltyCard);
  dateFrom$ = this.storeSelect(selectors.getDateFrom);
  dateUntil$ = this.storeSelect(selectors.getDateUntil);
  store$ = this.storeSelect(selectors.getStore);
  invoiceDate$ = this.storeSelect(selectors.getInvoiceDate);
  grandTotal$ = this.storeSelect(selectors.getGrandTotal);
  descending$ = this.storeSelect(selectors.getDescending);
  ascending$ = this.storeSelect(selectors.getAscending);
  creationDate$ = this.storeSelect(selectors.getCreationDate);
  gridInvoiceDate$ = this.storeSelect(selectors.getGridInvoiceDate);
  invoiceTime$ = this.storeSelect(selectors.getInvoiceTime);
  gridInvoiceNumber$ = this.storeSelect(selectors.getGridInvoiceNumber);
  gridGrandTotal$ = this.storeSelect(selectors.getGridGrandTotal);
  lineAmount$ = this.storeSelect(selectors.getLineAmount);
  returnPurchase$ = this.storeSelect(selectors.getReturnPurchase);
  remarks$ = this.storeSelect(selectors.getRemarks);
  return$ = this.storeSelect(selectors.getReturn);
  purchase$ = this.storeSelect(selectors.getPurchase);
  getGrandTotalTooltip$ = this.storeSelect(selectors.getGrandTotalTooltip);
  getAmountTooltip$ = this.storeSelect(selectors.getAmountTooltip);
  lineItem$ = this.storeSelect(selectors.getLineItem);
  coupons$ = this.storeSelect(selectors.getCoupons);
  attributes$ = this.storeSelect(selectors.getAttributes);
  productNumber$ = this.storeSelect(selectors.getProductNumber);
  lineDescription$ = this.storeSelect(selectors.getLineDescription);
  quantity$ = this.storeSelect(selectors.getQuantity);
  unitPrice$ = this.storeSelect(selectors.getUnitPrice);
  discount$ = this.storeSelect(selectors.getDiscount);
  amount$ = this.storeSelect(selectors.getAmount);
  couponsetId$ = this.storeSelect(selectors.getCouponsetId);
  couponCode$ = this.storeSelect(selectors.getCouponCode);

  // OBSERVABLE'S VALUES
  get invoiceNumber() {
    return this.storeSnapshot(this.invoiceNumber$);
  }

  get invoiceDate() {
    return this.storeSnapshot(this.invoiceDate$);
  }

  get grandTotal() {
    return this.storeSnapshot(this.grandTotal$);
  }

  get Store() {
    return this.storeSnapshot(this.store$);
  }

  get descending() {
    return this.storeSnapshot(this.descending$);
  }

  get ascending() {
    return this.storeSnapshot(this.ascending$);
  }

  get creationDate() {
    return this.storeSnapshot(this.creationDate$);
  }

  get gridInvoiceDate() {
    return this.storeSnapshot(this.gridInvoiceDate$);
  }

  get invoiceTime() {
    return this.storeSnapshot(this.invoiceTime$);
  }

  get gridInvoiceNumber() {
    return this.storeSnapshot(this.gridInvoiceNumber$);
  }

  get gridGrandTotal() {
    return this.storeSnapshot(this.gridGrandTotal$);
  }

  get lineAmount() {
    return this.storeSnapshot(this.lineAmount$);
  }

  get returnPurchase() {
    return this.storeSnapshot(this.returnPurchase$);
  }

  get remarks() {
    return this.storeSnapshot(this.remarks$);
  }

  get productNumber() {
    return this.storeSnapshot(this.productNumber$);
  }

  get lineDescription() {
    return this.storeSnapshot(this.lineDescription$);
  }

  get quantity() {
    return this.storeSnapshot(this.quantity$);
  }

  get unitPrice() {
    return this.storeSnapshot(this.unitPrice$);
  }

  get discount() {
    return this.storeSnapshot(this.discount$);
  }

  get amount() {
    return this.storeSnapshot(this.amount$);
  }

  get couponsetId() {
    return this.storeSnapshot(this.couponsetId$);
  }

  get couponCode() {
    return this.storeSnapshot(this.couponCode$);
  }
}
